import RichTextEditor from '../common/RichTextEditor';
import { normalizeEmailClipboardHtml, plainTextToEmailHtml, sanitizeEmailHtml } from '../../utils/emailHtml';

function isSafeUrl(value) {
  return /^(https?:\/\/|mailto:|tel:)/i.test(String(value || '').trim());
}

function normalizeUrl(value) {
  const url = String(value || '').trim();

  if (!url) return '';
  if (/^[a-z][a-z0-9+.-]*:/i.test(url)) return url;

  return `https://${url}`;
}

const emailColorOptions = [
  { label: 'Black', value: '#000000' },
  { label: 'Dark gray', value: '#374151' },
  { label: 'Red', value: '#dc2626' },
  { label: 'Green', value: '#16a34a' },
  { label: 'Blue', value: '#2563eb' },
];

function EmailRichTextEditor({ ariaLabel = 'Email body editor', value, onChange }) {
  return (
    <RichTextEditor
      allowLinkWithoutSelection
      ariaLabel={ariaLabel}
      className="email-rich-editor"
      collapseSelectionAfterCommand
      colorOptions={emailColorOptions}
      isSafeUrl={isSafeUrl}
      linkInputPlaceholder="https://example.com"
      normalizeClipboardHtml={normalizeEmailClipboardHtml}
      normalizePlainText={plainTextToEmailHtml}
      normalizeUrl={normalizeUrl}
      onChange={onChange}
      replaceDomOnSanitize={false}
      sanitizeHtml={sanitizeEmailHtml}
      showPasteMode
      surfaceClassName="email-rich-editor__surface"
      toolbarClassName="email-rich-editor__toolbar"
      value={value}
    />
  );
}

export default EmailRichTextEditor;
